import React, { useState } from "react";
import {
  Paper,
  Box,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Grid,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import TuneIcon from "@mui/icons-material/Tune";

function SubheaderModule({ module, onChange, onDelete, isEditable }) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [conditionalOpen, setConditionalOpen] = useState(false);

  const handleTextChange = (e) => {
    onChange({ ...module, text: e.target.value });
  };

  const handleRequiredToggle = (e) => {
    onChange({ ...module, required: e.target.checked });
  };

  const handleAdminWorkflowToggle = (e) => {
    onChange({ ...module, approvalRequired: e.target.checked });
  };

  return (
    <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
      {/* Module Header */}
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}>
        <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
          SUBHEADER MODULE
        </Typography>
        {isEditable && (
          <Box>
            <Tooltip title="Settings">
              <IconButton
                onClick={() => setSettingsOpen(!settingsOpen)}
                size="small"
              >
                <SettingsIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Conditional Visibility">
              <IconButton
                onClick={() => setConditionalOpen(!conditionalOpen)}
                size="small"
              >
                <TuneIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Module">
              <IconButton onClick={onDelete} size="small" color="error">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>

      {/* Module Preview */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 1,
          padding: 2,
          backgroundColor: "#fafafa",
          marginBottom: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontFamily: "Roboto", color: "#000" }}>
          {module.text || "Subheader Text"}
        </Typography>
      </Box>

      {/* Settings Panel */}
      {isEditable && settingsOpen && (
        <Box sx={{ marginTop: 2 }}>
          <TextField
            label="Subheader Text"
            value={module.text || ""}
            onChange={handleTextChange}
            fullWidth
          />

          {/* New Status Dropdowns */}
          <Grid container spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="editable-status-label">
                  Editable when in Status:
                </InputLabel>
                <Select
                  labelId="editable-status-label"
                  value={module.editableWhenStatus || 0}
                  onChange={(e) =>
                    onChange({ ...module, editableWhenStatus: e.target.value })
                  }
                  label="Editable when in Status:"
                >
                  <MenuItem value={0}>0, valid</MenuItem>
                  <MenuItem value={8}>8, Completed</MenuItem>
                  <MenuItem value={3}>3, Awaiting Review</MenuItem>
                  <MenuItem value={2}>2, Requested</MenuItem>
                  <MenuItem value={9}>9, Closed</MenuItem>
                  <MenuItem value={7}>7, Declined</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth margin="dense">
                <InputLabel id="visible-status-label">
                  Visible when in Status:
                </InputLabel>
                <Select
                  labelId="visible-status-label"
                  value={module.visibleWhenStatus || 0}
                  onChange={(e) =>
                    onChange({ ...module, visibleWhenStatus: e.target.value })
                  }
                  label="Visible when in Status:"
                >
                  <MenuItem value={0}>0, valid</MenuItem>
                  <MenuItem value={8}>8, Completed</MenuItem>
                  <MenuItem value={3}>3, Awaiting Review</MenuItem>
                  <MenuItem value={2}>2, Requested</MenuItem>
                  <MenuItem value={9}>9, Closed</MenuItem>
                  <MenuItem value={7}>7, Declined</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ marginTop: 1 }}>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={module.required || false}
                    onChange={handleRequiredToggle}
                    color="primary"
                  />
                }
                label="Required"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={module.approvalRequired || false}
                    onChange={handleAdminWorkflowToggle}
                    color="primary"
                  />
                }
                label="Admin Workflow"
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {isEditable && conditionalOpen && (
        <Box sx={{ marginTop: 2 }}>
          <Typography variant="body2">
            Conditional Visibility settings...
          </Typography>
        </Box>
      )}
    </Paper>
  );
}

export default SubheaderModule;
